<template>
  <div>
    <!-- 支付弹框 -->
    <pay-cont v-if="PayContShow"
              :CourseInfo="checkArr"
              :type=2
              :payType=1></pay-cont>
    <div class="gl_title_bar">
      <div class="gl_tb_left">
        <span class="normaltitle">我的购物车</span>
      </div>
    </div>
    <div v-if="tableData.length == 0"
         class="NoneData">
      <p>
        <i class="iconfont icon-wushujutanhao"></i>
        <span>暂无相关数据</span>
      </p>
    </div>
    <div v-else>
      <div class="titleBar display_flex marginTop20">
        <div class="publ_left_checkbox">
          <div class="publ_check">商品</div>
        </div>
        <div class="flex1 display_center">
          课时
        </div>
        <div class="flex1 display_center">
          单价
        </div>
        <div class="flex1 display_center">
          实付
        </div>
        <div class="flex1 display_center">
          操作
        </div>
      </div>
      <div class="pub_line"
           v-for="(item,index) in tableData"
           :key="index">
        <div class="publ_left_checkbox">
          <div class="publ_check">
            <el-checkbox :value="getCheck(item)"
                         @change="onTableSelect(item)"></el-checkbox>
          </div>
          <img :src="item.acr_Pict"
               style="width:122px; height:64px"
               class="publ_logo marginLeft20">
          <div class="pubTable_intro">
            <p class="pubtable_title">{{item.title}}</p>
            <p class="pubtable_title_date marginTop10">{{item.createTime}}</p>
          </div>
        </div>
        <div class="flex1 display_center">
          {{item.classHour}}
        </div>
        <div class="flex1 display_center">
          {{Number(item.price).toFixed(2)}}
        </div>
        <div class="flex1 display_center">
          {{Number(item.discount).toFixed(2)}}
        </div>
        <div class="flex1 display_center">
          <a href="javascript:;"
             @click.stop="SubDelte(item)">
            <img src="/image/geren/del_line.png"
                 alt="">
          </a>
        </div>
      </div>
      <div class="footbar display_between">
        <div class="publ_left_checkbox">
          <div class="publ_check">
            <el-checkbox class="marginRight20"
                         v-model="checkout"
                         @change="toggleSelection()">全选</el-checkbox>
          </div>
        </div>
        <div>
          <span class="marginRight20">已选 <span class="normalColor fontBold">{{Ischecked}}</span>个课程</span>
          <span class="marginRight10">总价：<span class="normalColor fontBold">¥{{Number(totalPrice).toFixed(2)}}</span></span>
          <a href="javascript:void(0);"
             class="settBtn"
             @click="PayCardMent()">去结算</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import payCont from './payCont.vue'
export default {
  inject: ['reload'],
  name: "userShopping",
  data () {
    return {
      // 用户id
      AuthorId: '',
      // 课程id
      rowId: '',
      // 支付弹框
      PayContShow: false,
      checkout: false,
      Ischecked: 0,
      totalPrice: 0,
      // 判断是否勾选
      selected: false,
      tableData: [],
      checkArr: [],
      userType: 0
    }
  },
  methods: {
    checkboxT (row, index) {
      if (row.is_Putaway == false) {
        return false
      } else {
        return true
      }
    },
    TomenuDetail (val) {
      if (val.is_Putaway == false) {
        this.$message({
          message: '商品已下架'
        })
      } else {
        let url = this.httphelper.IsDebugCgphome()+'/detail?courseId=' + val.courseId;
        window.open(url);
      }
    },
    // 获取购物车课程
    getChartCourse () {
      this.httphelper.post('/api/CGPInfoApi/GetMyGpChat',
        {
          userId: this.AuthorId
        }).then((res) => {
          this.tableData = res.data.data
        })
    },

    // 勾选课程，获取id
    onTableSelect (row) {
      for (let i = 0; i < this.checkArr.length; i++) {
        if (this.checkArr[i] == row) {
          this.checkArr.splice(i, 1);
          if (this.checkArr.length == 0) {
            this.checkout = false
          }
          return
        }
      }
      this.checkArr.push(row)
      if (this.checkArr.length == this.tableData.length) {
        this.checkout = true
      }
      // 课程id
      // this.rowId = row.myChatId
      // 判断是否选中
      //   this.selected = rows.length && rows.indexOf(row) !== -1
      // 选中id添加到字符串中
      //   this.courseId = rows.map(item => item.myChatId).join(',')
    },
    // 删除课程
    SubDelte (item) {
      // this.selected 选中id，false，true
      // this.rowId 判断是否有id选中
      if (item.myChatId) {
        this.$confirm('此操作将删除课程：' + item.title + ', 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.httphelper.post('/api/CGPInfoApi/DeleteGpChat', {
            chatInfoId: item.myChatId.toString(),
            userId: this.AuthorId
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: '删除失败',
                type: 'warning'
              })
            }
            this.getChartCourse()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    // 选中商品计算总价
    handleSelectionChange (val, row) {
      this.courseId = val.map(item => item.myChatId).join(',')
      this.multipleSelection = val
      this.Ischecked = val.length
      if (val.length == this.tableData.length) {
        this.checkout = true
      } else {
        this.checkout = false
      }

      var totalPrice = 0
      for (var k in val) {
        if (val[k].discount) {
          totalPrice = totalPrice + Number(val[k].discount)
        }
      }
      this.totalPrice = totalPrice

      this.CourseInfo = val

    },
    // 取消全选
    toggleSelection () {
      if (this.checkout) {
        this.checkArr = []
        for (let i = 0; i < this.tableData.length; i++) {
          this.checkArr.push(this.tableData[i])
        }
      } else {
        this.checkArr = []
      }
    },
    // 拉起支付弹框
    PayCardMent () {
      if (this.checkArr.length > 0) {
        if (this.userType == 1) {
          this.$message({
            message: '您已是SVIP，无需购买课程，请到我的课程中学习',
            type: 'success'
          })
          this.reload()
        } else {
          this.PayContShow = true
        }
      } else {
        this.$message({
          message: '请勾选课程',
          type: 'warning'
        })
      }
    },
    getCheck (item) {
      let che = false
      for (let i = 0; i < this.checkArr.length; i++) {
        if (this.checkArr[i] == item) {
          che = true
        }
      }
      return che
    }
  },
  components: {
    payCont
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
      this.userType = localStorage.getItem('userType')
    }
    this.getChartCourse()
  },
  watch: {
    checkArr () {
      let pic = 0
      for (let i = 0; i < this.checkArr.length; i++) {
        pic = pic + this.checkArr[i].discount
      }
      this.totalPrice = pic
      this.Ischecked = this.checkArr.length
    }
  }
}
</script>

<style scoped>
.NoneData {
    padding: 40px;
    text-align: center;
    color: #999;
    font-size: 18px;
    letter-spacing: 1px;
}
.NoneData i {
    font-size: 36px;
    color: #0b8586;
    position: relative;
    top: 7px;
    margin-right: 7px;
}
.titleBar {
    height: 40px;
    background: #f2f4f7;
    line-height: 40px;
}
.footbar {
    height: 50px;
    background: #f2f4f7;
    line-height: 50px;
}
.settBtn {
    display: inline-block;
    width: 102px;
    height: 50px;
    background: #0b8586;
    line-height: 50px;
    color: #fff;
    font-weight: bold;
    text-align: center;
}
.publ_left_checkbox {
    margin-left: 10px;
}
.publ_check ::v-deep .is-checked .el-checkbox__label {
    color: #0b8586;
}
.publ_check ::v-deep .is-checked .el-checkbox__inner {
    border-color: #0b8586;
    background-color: #0b8586;
}
</style>
